

export const showAlert = (message) => {
    if (typeof document !== 'undefined') {
        alert(message);
    } else {
        import('react-native').then(({ Alert }) => {
            Alert.alert('Erro', message);
        }).catch(() => {
            console.log('Erro ao exibir alerta nativo');
        });
    }
};